/* eslint-disable no-underscore-dangle */
import { AlgoliaUtils } from '@algolia/utils';
import { AlgoliaUiComponents } from '@algolia/widgets';

class AlgoliaSearchCollectionComponent {
  constructor(productSearch) {
    this.productSearch = productSearch;
    window.location.href.includes('/collections')
      ? (this.type = 'collection')
      : (this.type = 'search');
    this.init();
  }

  async initSearch() {
    const dataElem = document.querySelector('#collection-products-section-data');
    let data = {};
    try {
      data = dataElem ? JSON.parse(dataElem.textContent) : {};
    } catch (e) {
      // ignore invalid JSON
    }

    const productTitleTag = data.product_title_tag || 'span';
    const cardsView = data.cards_view === 'list' ? 'list' : 'grid';
    const showViewAs = data.show_view_as !== false;
    const showCategoryFilter = data.show_category_filter !== false;
    let config = {};
    if (this.type === 'search') {
      config = {
        useUrlQuery: true,
        useVirtualSearchBox: true,
        productTitleTag,
        cardsView,
        showViewAs,
        showCategoryFilter,
      };
    } else {
      const collectionId = data.collection_id || null;
      config = {
        filters: collectionId ? `collection_ids:${collectionId}` : '',
        productTitleTag,
        cardsView,
        showViewAs,
        showCategoryFilter,
      };
    }

    return this.productSearch.createSearchInstance(config);
  }

  async initWithRetry(initSearch, maxRetries = 3, delay = 1000, attempt = 1) {
    try {
      return await initSearch();
    } catch (error) {
      if (attempt >= maxRetries) {
        AlgoliaUtils.logError?.(error, `initWithRetry (attempt ${attempt})`);
        throw error;
      }

      await new Promise((resolve) => setTimeout(resolve, delay));
      return this.initWithRetry(initSearch, maxRetries, delay * 1.5, attempt + 1);
    }
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      try {
        if (typeof AlgoliaUiComponents.initializeFilterButtons === 'function') {
          AlgoliaUiComponents.initializeFilterButtons();
        }
      } catch (e) {
        // non-critical
      }
      this.initWithRetry(this.initSearch.bind(this)).catch((error) => {
        AlgoliaUtils.logError?.(error, 'Final initialization failure');
      });
    });
  }
}

// Usage
new AlgoliaSearchCollectionComponent(window.ProductSearch || (window.ProductSearch = {}));
